export default __webpack_public_path__ + "static/media/divider.810c1e1d.svg";